import React from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { resetAuthState } from 'redux/modules/Authorization/auth';
import { ROUTES } from 'config/routes';
import { PopupConfirm } from 'view/molecules/PopupConfirm';
import { logout } from 'static/icons/resizable';
import { APP_DEFAULT_LANGUAGE_KEY } from 'config';
import { localStorageManager } from 'services/localStorage';
import { resetDiscountEditor } from 'redux/modules/DiscountEditor/discountEditor';
import { HTTP } from 'services';
import { resetSelectedCategory } from 'redux/modules/Categories/categories';

type Props = {
  closeHandler: () => void;
  modalRef?: React.Ref<HTMLDivElement>;
};

export const LogoutModal = ({ closeHandler, modalRef }: Props) => {
  const { i18n, t } = useTranslation();

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const logOut = () => {
    HTTP.get('/logout');
    localStorageManager.clearStorage();
    dispatch(resetAuthState());
    dispatch(resetDiscountEditor());
    dispatch(resetSelectedCategory());
    i18n.changeLanguage(APP_DEFAULT_LANGUAGE_KEY);
    navigate(ROUTES.login, { replace: true });
  };

  return (
    <PopupConfirm
      modalRef={modalRef}
      title={t('profile.confirmation')}
      yesText={t('profile.logout')}
      cancelText={t('other.cancel')}
      confirmHandler={logOut}
      closeHandler={closeHandler}
      yesButtonSrcIcon={logout}
    />
  );
};
